@for (pick of picks; track pick.id.toString()) {
    <div class="linear-combo-bet-builder-details__pick">
        <span class="linear-combo-bet-builder-details__pick-name">{{ pick.eventName.name }}</span>
        @if (isBetBuilderPick(pick)) {
            <bs-linear-bet-builder-selections-list [pick]="pick" [inlineDetails]="true" />
        } @else {
            <bs-linear-bet-builder-selection-display [selection]="getPickSelection(pick)" [inlineDetails]="true" />
        }
    </div>
}
